import { gql } from 'react-apollo';

export const deleteSuccessReport = gql`
  mutation deleteSucessReport($input: DeleteSuccessReportInput!) {
    deleteSuccessReport(input: $input) {
      successReport: success_report {
        id
        text
        title
        type
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/successReports/mutations/deleteSuccessReport.js